import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { noop } from 'lodash';
import { Input } from 'shared/components';

import theme from './InputWithCharacterCounter.scss';

class InputWithCharacterCounter extends Component {

  static propTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    maxLength: PropTypes.number.isRequired,
  };

  static defaultProps = {
    defaultValue: '',
    onChange: noop,
  };

  constructor(props) {
    super(props);

    this.state = { currentLength: props.defaultValue.length };
  }

  handleOnChange = (value) => {
    this.setState({ currentLength: value.length });

    return this.props.onChange(value);
  };

  render() {
    return (
      <div>
        <Input { ...this.props } onChange={ this.handleOnChange } />

        <div className={ theme.lengthCounter }>
          <FormattedMessage
            id="Media.Media-Edit.EditDetailsDialog.CharactersRemainingTitle"
            defaultMessage="** Characters remaining: "
          />
          <span>
            { this.state.currentLength }{ '/' }{ this.props.maxLength }
          </span>
        </div>
      </div>
    );
  }
}

export default injectIntl(InputWithCharacterCounter);
